<template>
  <dialog-control :id="id"></dialog-control>
</template>

<script>
import DialogControl from "@/components/Moderator/DialogControl";

export default {
  components: {
    DialogControl
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>
